import { ChevronRight } from 'lucide-react'

import { Link } from '@/i18n/navigation'
import { cn } from '@/lib/utils'

type SeeAllLinkProps = {
  href: string
  label: string
  className?: string
}

export default function SeeAllLink({ href, label, className }: SeeAllLinkProps) {
  return (
    <Link href={href} className={cn('group flex items-center gap-[3px] font-normal', className)}>
      <span className="text-vive-primary-30 text-xs leading-normal whitespace-nowrap transition-colors duration-300 group-hover:text-white">
        {label}
      </span>
      <span className="grid size-3 shrink-0 place-items-center overflow-visible">
        <ChevronRight className="stroke-vive-primary-30 size-3 translate-x-0 transition-all duration-300 ease-out group-hover:translate-x-0.5 group-hover:scale-105 group-hover:stroke-white" />
      </span>
    </Link>
  )
}
